import styled from "styled-components";

const StyledCard = styled.div`
  padding-top: ${(props) =>
    props.style && props.style.cardPaddingTop
      ? props.style.cardPaddingTop
      : "80px"};
  padding-left: 80px;
  opacity: 0.8;
  width: ${(props) =>
    props.style && props.style.width ? props.style.width : "25rem"};
`;

const StyledCardBody = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
`;

const StyledCardTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
`;

export { StyledCard, StyledCardBody, StyledCardTitle };
